import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    OnInit,
    OnChanges,
    OnDestroy,
    Output,
} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {from, Subscription, switchMap, tap,} from 'rxjs';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import * as XLSX from 'xlsx'
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {TranslateService} from '@ngx-translate/core';
import {PaginationModel} from '../../../models/file-table.model';
import {ContractModel} from '../../../models/contract.model';
import {BUSINESS_ROLES, MemberModel, TBusinessRole} from '../../../models/user.model';
import {MemberService} from '../../../services/member.service';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {CrmService} from '../../../services/api/crm.service';
import {IRoleModel, TaskModel, UserTasksSettings} from '../../../models/task.model';
import {TaskServiceService} from '../../../services/task-service.service';
import {BoardGroupModel, BoardTableModel, TaskBoardModel, TaskTypesModel} from '../../../models/tasktable.model';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {
    TaskDetailCommentsComponent
} from '../../../components/task-detail/task-detail-comments/task-detail-comments.component';
import {AppTaskUsersList} from '../../../components/material/task-users-list/task-users-list';
import {HelpersService} from '../../../services/helpers.service';
import {
    OBJECT_COLLUMS_MAP_TASK,
    ROLES_ICONS_MAP,
    IMPORTANTANCE_COLORS
} from './table-tasks-const';
import {TaskDetailComponent} from '../../../components/task-detail/task-detail.component';
import {CUSTOM_PROPERTIES_POSTFIX_MAP, CUSTOM_PROPERTIES_PREFIX, PropertyModel} from '../../../models/property.model';
import {DocViewComponent} from '../../../components/doc-view/doc-view.component';
import {AppContentDialogComponentMT} from '../../../components/material/content-dialog/app-content-dialog.component';
import {ProfileCardModalComponent} from '../../../components/modal/profile-card-modal/profile-card-modal.component';
import {AppContractFormComponent} from "../../../modules/contracts/controller/contract-form/contract-form.component";

type TExtendeTaskModel = TaskModel & { expired?: boolean, content_desc?: string }

interface ILocalUserData {
    user_guid: string,
    role: TBusinessRole,
    full_name?: string|null
}

type TfilterType = 'deadline' | 'usersRoles' | 'userOwnRoles'

@Component({
    selector: 'app-tasks-table-mt',
    templateUrl: './table-tasks-mt.html',
    styleUrls: ['./table-tasks-mt.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMTTasksTable implements OnInit, OnChanges, OnDestroy {
    @Input() widgetView: boolean = false
    @Input() customColumns!: UserTasksSettings[]
    @Input() tasksData!: TaskModel[]
    @Input() onlyTable!: boolean
    @Input() headerTransparent!: boolean
    @Input() selectTargetMode: boolean = false;
    @Output() eventSubmitSelectedTask:EventEmitter <TaskModel> = new EventEmitter<TaskModel>()
    @Input() rowsPerPages: number = 50;
    public IMPORTANTANCE_COLORS = IMPORTANTANCE_COLORS
    public ROLES_ICONS_MAP = ROLES_ICONS_MAP
    public businessRolesList: TBusinessRole[] = [...BUSINESS_ROLES]
    public dataSource: MatTableDataSource<TExtendeTaskModel> = new MatTableDataSource();
    public dataComplete: TExtendeTaskModel [] = [];
    public usersInTasksListFiltered: ILocalUserData [] = [];
    public isExpired = false
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild('paginatorBottom') paginatorBottom!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    public textFilterInput = new FormControl('');
    public dataRange = new FormGroup({
        dateRangeStart: new FormControl<Date | null>(null),
        dateRangeEnd: new FormControl<Date | null>(null),
    });
    public panelOpenState = false;
    public searchForm: FormGroup;
    public pagination: PaginationModel = {
        limit: this.rowsPerPages,
        current_page: 1,
        board_statuses: '',
        board_alias: '',
        contract_is_empty: false,
        sort_by: 'updated_at',
        sort: 'desc',
    }
    //to be refactored
    @ViewChild('viewTaskView') public viewTaskView!: TemplateRef<any>;
    private contentDialogRef:MatDialogRef<any>|null = null;
    private selectedTask:TaskModel|null =null
    public dashes!: BoardTableModel[];
    public groups!: BoardGroupModel[];
    public selectedDash!: TaskBoardModel | BoardTableModel | null;
    public currentMember!: MemberModel;
    public description = '';
    //to be refactored
    changeBoard!: TaskBoardModel | null;
    selectedType!: TaskTypesModel | null;
    alias!: string;
    private columnsToDisplay: string[] = ['task_alias', 'title', 'status_current.label', 'task_board_name', 'importance', 'user_roles',
        'deadline_at', 'updated_at', 'comments_count', 'created_at', 'contract_guid', 'content', 'roles', 'task_type.name'];
    public customPropModels = new Map<string, PropertyModel>
    private subscriptions = new Subscription();
    private usersInTasksList = new Map <string, ILocalUserData>;
    private membersData!: MemberModel[];
    private complexFilter = new Map<TfilterType, any>
    private commentsDialogRef!: MatDialogRef<TaskDetailCommentsComponent>
    private usersDialogRef!: MatDialogRef<AppTaskUsersList>

    constructor(
        private crmService: CrmService,
        private memberService: MemberService,
        private taskServiceService: TaskServiceService,
        private fb: FormBuilder,
        private router: Router,
        private alertService: AlertService,
        protected modalService: ModalService,
        private helpersService: HelpersService,
        public translate: TranslateService,
        private dialog: MatDialog,
       // private currentDialogRef: MatDialogRef<AppMTTasksTable>,
    ) {
        this.searchForm = this.fb.group({
            dateRange: {value: null, disabled: true},
            contract_is_empty: {value: false, disabled: false},
            businessRolesListFG: {value: [], disabled: false},
            businessProcessFG: {value: [], disabled: false}
        })
    }

    ngOnInit(): void {
      this.selectTargetMode? this.fcontractIsEmpty?.patchValue(true) : null;
      if (this.widgetView === false) {
        this.setSubscriptions();
        this.submitQuery(false,false,true)
      } else {
        this.paginator = this.paginatorBottom;
      }
      //to be refactored
      this.taskServiceService.getAllBoards(false).then(result => {
        this.dashes = result.boards.filter(onlyBoard => onlyBoard.rights && onlyBoard.rights.is_create_new_task);
        this.groups = result.groups;
        result.groups.map((x: BoardGroupModel) => {
            const boardsWithPermissions = x.boards.filter(groupBoard => groupBoard.rights && groupBoard.rights.is_create_new_task);
            this.dashes = this.dashes.concat(boardsWithPermissions).sort((a, b) => a.alias.toLocaleLowerCase() > b.alias.toLocaleLowerCase() ? 1 : -1);
        });
      });
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes?.tasksData?.currentValue) {
          changes.customColumns?.currentValue ? this.updateCustomCollunms() : null;
          this.updateDataSource(this.flattenComplexData(changes.tasksData.currentValue))
      }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    setSubscriptions() {
        this.subscriptions.add(this.fBusinessRolesList?.valueChanges.subscribe((rolesSelected: TBusinessRole[]) => this.searchFormBusinessRoleChanged(rolesSelected)))
        this.subscriptions.add(this.textFilterInput.valueChanges.subscribe(fil => fil ? this.dataSource.filter = fil : null))
        this.subscriptions.add(this.crmService.subTaskData
            .subscribe(firstPage => this.updateDataSource(this.flattenComplexData(firstPage.data),false)))
    }

    updateDataSource(data: TaskModel[], showAlert: boolean = false, changeCompleteSet = true) {
        let usersSet = new Set <string>
        this.usersInTasksList.clear()
        data = data.map(el => {
            el?.roles ? Object.keys(el.roles)?.forEach(role => el.roles[role as keyof typeof el.roles]?.forEach((user_guid: IRoleModel) => {
                usersSet.add(user_guid.user_guid)
                this.usersInTasksList.set(user_guid.user_guid + "_" + role, {
                    role: role as TBusinessRole,
                    user_guid: user_guid.user_guid,
                    full_name: ''
                })
            })) : null;
            return {
                ...el,
                expired: el?.deadline_at && new Date(el?.deadline_at).getTime() < new Date().getTime(),
                content_desc: el.content ? this.clearText(el.content) : '',
            }
        })
        this.memberService.memberGuidsHandler([...usersSet]).then(data => this.membersData = data)
        this.dataSource.data = data
        changeCompleteSet ? this.dataComplete = data : null;
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
        showAlert ? this.alertService.setAlert(this.translate.instant('NOTIFY.LOADED_ROWS').replace('${1}', data.length), 'green') : null
    }

    submitQuery(showAlert = true, clearDataSource = false, flattenComplexData = true) {
      clearDataSource ? this.dataSource.data = [] : null;
      this.pagination.roles = this.fBusinessRolesList ? this.fBusinessRolesList.value.join().replaceAll('all_roles', '') : []
      this.pagination.contract_is_empty = this.fcontractIsEmpty ? this.fcontractIsEmpty.value : null;
      this.subscriptions.add(
          from(this.memberService.getCurrentMember())
              .pipe(
                  tap(member => this.currentMember = member),
                  switchMap(() => this.fbusinessProcess?.value?.length >0 ?
                      this.crmService.getAllTasksByPagesManyBoards(this.currentMember.guid, null, this.pagination, this.fbusinessProcess?.value)
                      : this.crmService.getAllTasksByPages(this.currentMember.guid, null, this.pagination)
                  )
              )
              .subscribe(data => this.updateDataSource(flattenComplexData? this.flattenComplexData(data) : data, showAlert))
      )
    }

    updateCustomCollunms() {
        this.customColumns.forEach(el => OBJECT_COLLUMS_MAP_TASK.get(el.alias)?.length ? el.alias = (OBJECT_COLLUMS_MAP_TASK.get(el.alias) || '') : el.alias)
        this.columnsToDisplay = this.customColumns.map(el => {
            let postFix = el.model?.is_multiform ? '' : CUSTOM_PROPERTIES_POSTFIX_MAP.get(el.model?.property_type)
            let colName = el.model ? CUSTOM_PROPERTIES_PREFIX + el.alias + postFix : el.alias
            el.model ? this.customPropModels.set(colName, el.model) : null
            return colName
        })
    }

    flattenComplexData(data: TaskModel[]): TaskModel[] {
        let deepColumns = this.columnsToDisplay.filter(el => el.includes('.'))
        data.forEach(row =>
            deepColumns.forEach(columnKey => {
                let keys: any
                keys = columnKey.split('.')
                Object.assign(row, {[columnKey]: keys.reduce((prev: any, curr: any) => prev?.[curr], row)});
                let customPropModel = this.customPropModels.get(columnKey)
                if ((row as any)[columnKey]?.length > 0 && customPropModel?.is_multiform === true) {
                    let postFix = CUSTOM_PROPERTIES_POSTFIX_MAP.get(customPropModel.property_type)?.replaceAll('.', '').trim();
                    postFix ? (row as any)[columnKey] = (row as any)[columnKey].map((el: any) => el[postFix]).join(', ') : null;
                }
            })
        )
        return data
    }
    selectTask(taskRow:TaskModel){
      if (this.selectTargetMode === false) {
        return
      }
      this.selectedTask = taskRow
    }
    submitSelectedTarget() {
      this.selectedTask? this.eventSubmitSelectedTask.next(this.selectedTask) : null
      //this.currentDialogRef.close()
    }

    openDialog(content: TemplateRef<any>,minWidth?:number,minHeight?:number) {
      this.contentDialogRef = this.dialog.open(AppContentDialogComponentMT,{
        panelClass:'file-toolbar-dialog',minHeight:minHeight,minWidth:minWidth, maxHeight:'95vh'
    })
      this.contentDialogRef.componentInstance.templateRef = content
    }
    //TextFilter
    textFilterUpdate(value: string) {
        this.dataSource.filter = value
        this.textFilterInput.patchValue(value)
    }

    textFilterClear() {
        this.dataSource.filter = ''
        this.textFilterInput.patchValue('')
    }

    //ComplexFilter
    complexFilterUserRoleChanged(rolesSelected: TBusinessRole[]) {
        this.updateDataSource(
            structuredClone(this.dataComplete)
            .filter(el => el.user_roles.some(role => rolesSelected.includes(role as TBusinessRole))), false, false)
    }

    complexFilterMemberRolesChanged(role: TBusinessRole) {
        this.usersInTasksListFiltered = [...this.usersInTasksList].filter(el => el[1].role === role)
            .map(data => {
                let member = this.membersData.find(el => el.guid === data[1].user_guid)
                return {
                    user_guid: data[1].user_guid,
                    role: data[1].role as TBusinessRole,
                    full_name: member ? this.helpersService.fullName(member) : ''
                }
            })
    }

    complexFilterMemberChanged(userData: ILocalUserData, cascade = true) {
        if (userData?.user_guid) { 
            this.complexFilter.set('usersRoles', userData)
                let data =  structuredClone(cascade ? this.dataComplete : this.dataSource.data)
                data = data.filter(row=>{
                let roles = (row.roles as any)[userData.role] as IRoleModel[];
                let users = roles.map(member=>member.user_guid)
                return users.includes(userData.user_guid)
                })
            this.updateDataSource(data  , false, false)
        }
    }

    complexFilterOverdueChanged(checked: boolean, cascade = true) {
        if (checked !== undefined) {
            let data = structuredClone(cascade ? this.dataComplete : this.dataSource.data)
            data = checked ? data.filter(el => el.expired === checked) : data
            this.updateDataSource(data, false, false)
            this.complexFilter.set('deadline', checked)
            cascade ? this.complexFilterUpdate('deadline') : null
        }
    }

    complexFilterReset() {
        this.complexFilter.clear()
        this.updateDataSource(this.dataComplete, false, false)
        this.usersInTasksListFiltered = []
        this.isExpired = false
    }

    complexFilterUpdate(updatedFilter: TfilterType) {
        updatedFilter === 'deadline' ? null : this.complexFilterOverdueChanged(this.complexFilter.get('deadline'), false)
        updatedFilter === 'usersRoles' ? null : this.complexFilterMemberChanged(this.complexFilter.get('usersRoles'), false)
    }

    searchFormBusinessRoleChanged(rolesSelected: TBusinessRole[]) {
        rolesSelected.length === BUSINESS_ROLES.length - 1 && !rolesSelected.includes('all_roles') ? this.fBusinessRolesList?.value.push("all_roles") : null;
        rolesSelected.length !== BUSINESS_ROLES.length && rolesSelected.includes('all_roles') ? this.fBusinessRolesList?.value.shift() : null
        this.fBusinessRolesList?.patchValue(this.fBusinessRolesList.value, {emitEvent: false})
    }

    searchFormBusinessRoleToggleAll() {
        this.fBusinessRolesList?.patchValue(this.fBusinessRolesList?.value.includes('all_roles') ? [] : [...BUSINESS_ROLES], {emitEvent: false})
    }

    //Table

    tableOpenContractForm(guid: string) {
        let contractDialogRef = this.dialog.open(AppContractFormComponent, {
            maxWidth: '1500px',
            minWidth: '80%',
            minHeight: '96vh',
            panelClass: 'task-table-padding-modalbox'
        });
        contractDialogRef.componentInstance.contractGuid = guid
    }

    tableShowComments(taskData: TaskModel) {
        this.commentsDialogRef = this.dialog.open(TaskDetailCommentsComponent, {minHeight: '60vh', maxHeight:'90vh', minWidth:'650px', panelClass: 'task-table-padding-modalbox'})
        this.commentsDialogRef.componentInstance.canCreateComments = false;
        this.commentsDialogRef.componentInstance.key = taskData.task_alias;
        this.commentsDialogRef.componentInstance.taskData = taskData;
        this.commentsDialogRef.componentInstance.commentsType = "task";
    }

    tableShowUsersInContract(taskData: TaskModel) {
        this.usersDialogRef = this.dialog.open(AppTaskUsersList)
        this.usersDialogRef.componentInstance.taskData = taskData;
        this.usersDialogRef.componentInstance.is_project_admin = this.currentMember.project_setting?.is_project_admin || false;
    }

    openFile(documentKey: string) {
        let docViewComponentDialogRef = this.dialog.open(DocViewComponent, {
            minWidth: '100vw',
            minHeight: '96vh',
            panelClass: 'task-table-padding-modalbox'
        })
        docViewComponentDialogRef.componentInstance.fileUkey = documentKey
        docViewComponentDialogRef.componentInstance.zoomExt = '100'

    }

    openMember(memberGuid: string) {
        let userComponentDialogRef = this.dialog.open(ProfileCardModalComponent, {
            maxWidth: '1500px',
            width: '700px',
            minHeight: '40vh',
            panelClass: 'task-table-padding-modalbox'
        })
        userComponentDialogRef.componentInstance.memberGuid = memberGuid
        userComponentDialogRef.componentInstance.modalView = false
    }

    openContentDialog(task: TaskModel) {
        let contentDialogRef = this.dialog.open(AppContentDialogComponentMT, {panelClass: 'task-table-padding-modalbox'})
        contentDialogRef.componentInstance.htmlContent = task.content
    }

    tableDropColumn(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.columnsToDisplay, event.previousIndex, event.currentIndex);
    }

    //Add-ons
    clearText(val: string): string {
        return val.replace(/<[^>]*>/g, '');
    }

    exportToExcel() {
        let dataTypes: any = {
            updated_at: 'Date',
            deadline_at: 'Date',
            created_at: 'Date',
        }
        let dataToExport = structuredClone(this.dataSource.data);
        dataToExport.map((el: any) => {
            Object.keys(el).forEach((key: string) => {
                switch (true == true) {
                    case el[key] && dataTypes[key] === 'number':
                        return el[key] = Number(el[key])
                    case el[key] && dataTypes[key] === 'Date':
                        return el[key] = new Date(el[key])
                    default:
                        return el[key] = el[key]
                }
            })
            return el;
        });
        const fileName = 'Задачи' + ".xlsx";
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'контракты');
        XLSX.writeFile(wb, fileName);
    }

    onOpenCreateTaskModal(content: TemplateRef<any>): void {
        this.modalService.openTemplateModal(content);
    }

    onCreateTask(modal: NgbModalRef, name: string): void {
        if (!name) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_TASK_NAME'), 'blue');
        }
        if (!this.selectedDash) {
            return this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_TASK_BP'), 'blue');
        }
        if (!this.selectedType) {
            return this.alertService.setAlert(this.translate.instant('CREATE_TASK_TYPE'), 'blue');
        }
        const taskData = {
            title: name,
            content: this.description,
            board_alias: this.selectedDash.alias,
            task_type_id: this.selectedType.id,
        };
        this.crmService.createTask(taskData).subscribe({
            next: data => {
                this.contentDialogRef?.close();
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'nd_color');
                this.changeBoard = null;
                this.selectedType = null;
                this.changeTask(data.task)
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }

    selectBoard(board: BoardTableModel | TaskBoardModel): void {
        this.taskServiceService.getBoard(board.alias, true).then(res => {
            this.changeBoard = res.board;
            this.selectedType = this.changeBoard.task_types[0];
        });

    }

    changeTask(task: TaskModel): void {
        let dialogRef = this.dialog.open(TaskDetailComponent, {
            panelClass: 'task-table-padding-modalbox',
            height: '90%',
            maxHeight: '100%',
            width: '80%',
            maxWidth: '100vw'
        })
        dialogRef.componentInstance.taskAlias = task.task_alias
        dialogRef.afterClosed().subscribe(()=>{
          if (this.selectTargetMode === true) {
            this.submitQuery(false,true,true)
            this.selectedTask = task
          }
        })
        // dialogRef.componentInstance.taskData = task
    }

    get gRange() {
        return this.searchForm.get('dataRange')
    }

    get fBusinessRolesList() {
        return this.searchForm.get('businessRolesListFG')
    }

    get fbusinessProcess() {
        return this.searchForm.get('businessProcessFG')
    }

    get fcontractIsEmpty() {
        return this.searchForm.get('contract_is_empty')
    }
}